import GetData from "@/utils/request.js"

const {
  $get,
  $post
} = new GetData();

export const placeOrder = (data) => {
  return $post('/h5/order/wxH5PayOrder', data);
}

export const paySuccess = (orderNo	) => {
  return $get('/h5/order/ordersuccess' ,{orderNo});
}

export const minOrder = data => $post(`/h5/order/wxMniAppPayOrder`, data)


export default {
  placeOrder,
  paySuccess,
  minOrder
}